<template lang="pug">
	#sfc-main-container.sfc-container-redesign-v1
		sfc-sentry
		sfc-dfp
		sfc-heap
		sfc-login
		sfc-forgot-password
		sfc-menu
		sfc-menu-mobile
		sfc-onboarding-modal-v2
		sfc-header
		#sfc-main-content
			nuxt
		no-ssr(v-if="!userSubscribed()")
			b-row#bottom-ad
				.col-md-12.col-sm-12.col-xs-12.ad-align-center
					.bottom-banner(style="")
						sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
		sfc-footer
		no-ssr
			sfc-gdpr-banner
</template>

<style lang="stylus" scoped>
	@import '~assets/css/general.styl'

	>>>
		.top-sponsor-container
			#top-banner-desktop
				background: sfc-layout-background
				border: none
				&:not(.empty)
					background: sfc-layout-background !important
					border: none
		.top-sponsor-container-mobile
			padding-top: 10px
			background: sfc-layout-background
			#top-banner-mobile
				background: sfc-layout-background
				border: none
				&:not(.empty)
					background: sfc-layout-background !important
					border: none !important
		#bottom-ad
			background: sfc-layout-background
			border: none !important
			@media (min-width: 768px)
				margin-top: -90px

	#sfc-main-content
		padding: 0px 15px 30px 15px
		background: sfc-layout-background !important

</style>

<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
